import {
  CCol,
  CContainer,
  CRow,
  CCloseButton,
  COffcanvas,
  COffcanvasBody,
  COffcanvasHeader,
  COffcanvasTitle,
  CCollapse,
} from "@coreui/react";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";
import {
  faLocationPin,
  faPhone,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import logo from "../assests/business-white-logo.png";
import offcanvasLogo from "../assests/business-color-logo.png";
// import logo1 from "../assests/ndis1.jpg";
import logo2 from "../assests/ndis2.jpg";
import BurgerMenu from "../assests/menu.png";
import staticData from "../assests/staticData.json";

export default function Header() {
  const [visible, setVisible] = useState(false);
  const [visibleCollapes, setVisibleCollapes] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const { service_list } = staticData;

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <>
      <div className="info-header-wrapper d-lg-block d-none">
        <CContainer>
          <CRow className="align-items-center">
            <CCol lg={6}>
              <div className="info-header-social">
                <ul className="social-share-list">
                  <li>
                    <Link
                      to="https://www.facebook.com/wattlecare"
                      target="_blank"
                    >
                      <FontAwesomeIcon icon={faFacebookF} />
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="https://www.instagram.com/wattlecarendis25/"
                      target="_blank"
                    >
                      <FontAwesomeIcon icon={faInstagram} />
                    </Link>
                  </li>
                  {/* <li>
                    <Link to="/" target="_blank">
                      <FontAwesomeIcon icon={faLinkedin} />
                    </Link>
                  </li> */}
                </ul>
              </div>
            </CCol>
            <CCol lg={6}>
              <div className="text-end ">
                <p className="mb-0 themeColorPara">
                  <FontAwesomeIcon icon={faLocationPin} className="pe-1" />
                  Level 2, Suite 3, 91 George Street, Parramatta 2150 NSW
                </p>
              </div>
            </CCol>
          </CRow>
        </CContainer>
      </div>

      <div
        id="header-sticky"
        className={`meta-header-area ${isSticky ? "sticky" : ""}`}
      >
        <CContainer>
          <div className="meta-header-inner">
            <div className="meta-header-left">
              <div className="header-logo header2-logo">
                <Link to={"/"} className="d-inline-block">
                  <img src={logo} alt="logo"></img>
                </Link>
              </div>
            </div>
            <div className="meta-header-right">
              <div className="meta-items meta-header-meta-items d-none d-lg-inline-flex">
                <div className="meta-item">
                  <div className="meta-item-icon">
                    <FontAwesomeIcon icon={faPhone} />
                  </div>
                  <div className="meta-item-content">
                    <p className="mb-0">Phone</p>
                    <div
                      className="meta-title"
                      style={{ fontFamily: "Poppins, sans-serif" }}
                    >
                      1800204050
                    </div>
                  </div>
                </div>
                <div className="meta-item d-none d-xl-inline-flex">
                  <div className="meta-item-icon">
                    <FontAwesomeIcon icon={faEnvelope} />
                  </div>
                  <div className="meta-item-content">
                    <p className="mb-0">Email</p>
                    <div className="meta-title">info@wattlecare.au</div>
                  </div>
                </div>
              </div>
              <div className="main-menu main-menu2">
                <nav id="mobile-menu-sticky">
                  <ul className="mb-0">
                    <li>
                      <Link to={"/"}>Home</Link>
                    </li>
                    <li>
                      <Link to={"/about"}>About Us</Link>
                    </li>
                    <li className="active menu-item-has-children">
                      <Link to={"/services"}>Services +</Link>
                      <ul className="sub-menu">
                        {service_list.length > 0 &&
                          service_list.map((nav) => (
                            <li key={nav.id}>
                              <Link to={`${nav.list_link}`}>
                                {nav.list_title}
                              </Link>
                            </li>
                          ))}
                      </ul>
                    </li>
                    <li>
                      <Link to={"/contact"}>Contact</Link>
                    </li>
                  </ul>
                </nav>
              </div>
              <Link
                to={"/referrels"}
                className="border-btn-rounded3 d-none d-lg-inline-flex"
              >
                <span>Referrels</span>
              </Link>
              <Link
                to={"/join-our-team"}
                className="border-btn-rounded2 d-none d-lg-inline-flex"
              >
                <span>Join Our Team</span>
              </Link>
              <div className="menu-bar d-lg-none">
                <button
                  type="button"
                  onClick={() => setVisible(true)}
                  style={{ background: "transparent", border: "none" }}
                >
                  <img
                    src={BurgerMenu}
                    alt="menu"
                    className="img-fluid"
                    width={30}
                  />
                </button>
              </div>
            </div>
          </div>
        </CContainer>
      </div>

      <div className="header-main header-main2 d-none d-lg-block">
        <CContainer>
          <CRow className="align-items-center">
            <CCol xl={12} lg={12}>
              <div className="header-main-content-wrapper">
                <div className="header-main-left header-main-left-header2">
                  <div className="main-menu main-menu2 d-none d-lg-inline-block">
                    <nav id="mobile-menu2">
                      <ul className="mb-0">
                        <li>
                          <Link to={"/"}>Home</Link>
                        </li>
                        <li>
                          <Link to={"/about"}>About</Link>
                        </li>
                        <li className="active menu-item-has-children">
                          <Link to={"/services"}>Services +</Link>
                          <ul className="sub-menu">
                            {service_list.length > 0 &&
                              service_list.map((nav) => (
                                <li key={nav.id}>
                                  <Link to={`${nav.list_link}`}>
                                    {nav.list_title}
                                  </Link>
                                </li>
                              ))}
                          </ul>
                        </li>
                        <li>
                          <Link to={"/contact"}>Contact</Link>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
                <div className="header-main-right header-main-right-header2">
                  <div className="meta-item">
                    {/* <img src={logo1} alt="service-logo" width={150} /> */}
                  </div>
                </div>
                <div className="header-main-right header-main-right-header2">
                  <div className="meta-item">
                    <img src={logo2} alt="service-logo" width={150} />
                  </div>
                </div>
              </div>
            </CCol>
          </CRow>
        </CContainer>
      </div>
      <COffcanvas
        placement="end"
        visible={visible}
        onHide={() => setVisible(false)}
      >
        <COffcanvasHeader className="justify-content-between">
          <COffcanvasTitle>
            <img src={offcanvasLogo} alt="logo" className="img-fluid" />
          </COffcanvasTitle>
          <CCloseButton
            className="text-reset"
            onClick={() => setVisible(false)}
          />
        </COffcanvasHeader>
        <COffcanvasBody>
          <div className="mob-navigation-layout-wrapper">
            <div className="mob-navigation-body mb-5">
              <ul className="mob-navigation-list mb-0">
                <li>
                  <Link to={"/"}>Home</Link>
                </li>
                <li>
                  <Link to={"/about"}>About Us</Link>
                </li>
                <li>
                  <button
                    type="button"
                    onClick={() => setVisibleCollapes(!visibleCollapes)}
                  >
                    Services +
                  </button>
                  <CCollapse visible={visibleCollapes}>
                    <ul className="collapes-menu-list">
                      {service_list.length > 0 &&
                        service_list.map((nav) => (
                          <li key={nav.id}>
                            <Link to={`${nav.list_link}`}>
                              {nav.list_title}
                            </Link>
                          </li>
                        ))}
                    </ul>
                  </CCollapse>
                </li>
                <li>
                  <Link to={"/contact"}>Contact Us</Link>
                </li>
              </ul>
            </div>
            <div className="mob-navigation-footer">
              <div className="mob-navigation-footer-content">
                <div className="mob-navigation-footer-buttons">
                  <CRow className="gx-3">
                    <CCol xs={6}>
                      <div className="mob-action-btn">
                        <Link to={"/referrels"}>Referrels</Link>
                      </div>
                    </CCol>
                    <CCol xs={6}>
                      <div className="mob-action-btn filled-btn">
                        <Link to={"/join-our-team"}>Join Our Team</Link>
                      </div>
                    </CCol>
                  </CRow>
                </div>
                <div className="mob-navigation-footer-info">
                  <div className="mnf-info-wrapper">
                    <div className="mnf-info-icon">
                      <span>
                        <FontAwesomeIcon icon={faPhone} />
                      </span>
                    </div>
                    <div className="mnf-info-icon-desc">
                      <span className="d-block">Contact Now</span>
                      <Link to="tel:1800204050" className="d-block">
                        1800204050
                      </Link>
                      {/* <Link to={"#"} className="d-block">
                        0489 073 262
                      </Link> */}
                    </div>
                  </div>
                </div>
                <div className="mob-navigation-footer-social">
                  <ul>
                    <li>
                      <label>Connect:</label>
                    </li>
                    <li>
                      <Link
                        to="https://www.facebook.com/wattlecare"
                        target="_blank"
                      >
                        <FontAwesomeIcon icon={faFacebookF} />
                      </Link>
                    </li>
                    <li>
                        <Link
                          to="https://www.instagram.com/wattlecarendis25/"
                          target="_blank"
                        >
                          <FontAwesomeIcon icon={faInstagram} />
                        </Link>
                      </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </COffcanvasBody>
      </COffcanvas>
    </>
  );
}
